import { aboutData } from "./data";

// HubSpot config. Portal/form IDs and region are public (they appear in the
// form embed on the live page), so they're safe as defaults. The M87 account
// is in the EU data region, so submissions go to the api-eu1 host.
const HUBSPOT_PORTAL_ID =
  process.env.REACT_APP_HUBSPOT_PORTAL_ID || "148474136";
const HUBSPOT_FORM_ID =
  process.env.REACT_APP_HUBSPOT_FORM_ID ||
  "6046bd6b-2eb7-45e8-9258-86ae4e8ff29d";
const HUBSPOT_REGION = process.env.REACT_APP_HUBSPOT_REGION || "eu1";

const hubspotHost =
  HUBSPOT_REGION === "na1"
    ? "api.hsforms.com"
    : `api-${HUBSPOT_REGION}.hsforms.com`;

// Submits a contact-form lead to HubSpot via the Forms API. Name, email and
// company map to their own structured contact fields. (Company lands correctly
// because its form field is bound to the Contact "Company name" property - a
// Company-object binding would be dropped here.) The selected plan goes in the
// message, since the form has no dedicated plan field.
export async function submitLead(form) {
  const portalId = HUBSPOT_PORTAL_ID;
  const formId = HUBSPOT_FORM_ID;

  const messageBody = [
    `Interested in: ${form.interest}`,
    form.message ? `\n${form.message}` : null,
  ]
    .filter(Boolean)
    .join("\n")
    .trim();

  if (portalId && formId) {
    const res = await fetch(
      `https://${hubspotHost}/submissions/v3/integration/submit/${portalId}/${formId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fields: [
            { objectTypeId: "0-1", name: "email", value: form.email },
            { objectTypeId: "0-1", name: "firstname", value: form.name },
            { objectTypeId: "0-1", name: "company", value: form.company },
            { objectTypeId: "0-1", name: "message", value: messageBody },
          ].filter((f) => f.value),
          context: { pageUri: window.location.href, pageName: document.title },
        }),
      }
    );
    if (!res.ok) throw new Error("HubSpot submission failed");
    return { method: "hubspot" };
  }

  // Fallback: compose an email to the team inbox.
  const subject = `New enquiry${form.interest ? ` - ${form.interest}` : ""}`;
  const body = [`Name: ${form.name}`, `Email: ${form.email}`, "", messageBody]
    .filter((l) => l !== null)
    .join("\n");
  window.location.href = `mailto:${aboutData.mail}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
  return { method: "mailto" };
}
